import React from 'react';
import { View, Text, StyleSheet, ScrollView, TouchableOpacity, Platform } from 'react-native';
import { FlashList } from '@shopify/flash-list';
import Colors from '../../constants/Colors';
import CS from '../../constants/Styles';
import { Button, BackgroundGradient, Loader, SafeAreaView } from '../../components';
import * as rtApi from '../../components/Api';
import UserAvatar from '../../components/Users/UserAvatar';
import ProjectPreview from '../../components/Projects/ProjectPreview';
import { FontAwesome, Ionicons, MaterialCommunityIcons, MaterialIcons, FontAwesome5 } from '@expo/vector-icons';
import UserState from '../../src/contexts/UserState';
import * as MailComposer from 'expo-mail-composer';
import MapView, { Marker } from 'react-native-maps';
import * as Linking from 'expo-linking';
import * as Contacts from 'expo-contacts';
import { splitFullName, stripPhoneNumber } from '../../utils/Functions';
import Projects from '../Projects/ProjectsScreen';
import * as Device from 'expo-device';
import { useLinkTo } from '@react-navigation/native';

const CustomerScreen = ({ navigation, route }) => {
  const [user, setUser] = React.useContext(UserState);
  const [loading, setLoading] = React.useState(false);
  const [customer, setCustomer] = React.useState({});
  const [projects, setProjects] = React.useState([]);
  // const [availableProjects, setAvailableProjects] = React.useState([]);

  const [isTablet, setIsTablet] = React.useState(false);
  const [isWeb, setIsWeb] = React.useState(Platform.OS === 'web');
  const [isReady, setIsReady] = React.useState(false);

  const scrollRef = React.useRef(null);
  const addContactIcon = <Ionicons name="md-person-add" size={26} color={Colors.blue2} />;
  const linkTo = useLinkTo();

  // runs each time screen is focused
  React.useEffect(() => {
    if (route.params?.customerId) {
      console.log('useEffect customerId', route.params?.customerId);
      getCustomer(route.params.customerId);
    }
    return () => rtApi.cancel();
  }, [route.params?.customerId]);

  React.useEffect(() => {
    (async () => {
      const deviceType = await Device.getDeviceTypeAsync();
      console.log('deviceType: ', deviceType);
      setIsTablet(deviceType === Device.DeviceType.TABLET ? true : false);
      setIsReady(true);
    })()
  }, []);

  const getCustomer = async (id) => {
    setLoading(true);

    rtApi.get(`users/${id}`)
    .then(data => {
      if (data.notLoggedIn) { setUser({ isLoggedIn: false }); rtApi.cancel(); return; }
      setCustomer(data.user);
      setProjects(data.agreements);
      // processProjects(data.agreements);
    }).catch(err => {
      console.log(err);
    }).finally(() => {
      setLoading(false);
    });
  }
  const invite = () => {
    console.log('invite this bitch');
    console.log(`/customer/${customer.id}/invite?inviteType=Customer&name=${customer.first_name + ' ' + customer.last_name}&email=${customer.email_address}&phone=${customer.mobile || customer.home}&customerId=${customer.id}`);
    linkTo(`/customer/${customer.id}/invite?inviteType=Customer&name=${customer.first_name + ' ' + customer.last_name}&email=${customer.email_address}&phone=${customer.mobile || customer.home}&customerId=${customer.id}&role=contractor`);
    // console.log(`/customer/${customer.id}/invite?name=${customer.first_name + ' ' + customer.last_name}&email=${customer.email_address}&phone=${customer.mobile || customer.home}`);
    // linkTo(`/customer/${customer.id}/invite?&name=${customer.first_name + ' ' + customer.last_name}&email=${customer.email_address}&phone=${customer.mobile || customer.home}`);
  }

  //contact
  const checkAddToContacts = () => {
    // alert('Add ??');
    (async () => {
      const result = await Contacts.getPermissionsAsync();
      console.log('result', result);
      if (result.status === 'granted') {
        //add
        addToContacts();
      } else if (result.status === 'undetermined') {
        //ask
        (async () => {
          const { status } = await Contacts.requestPermissionsAsync();
          if (status === 'granted') {
            addToContacts();
          }
        })();
      } else if (result.status === 'denied') {
        if (result.canAskAgain) {
          (async () => {
            const { status } = await Contacts.requestPermissionsAsync();
            if (status === 'granted') {
              addToContacts();
            }
          })();
        } else {
          Alert.alert(
            'Permission Denied',
            'You have perviously denied access to your contacts. Please allow access if you would like to add this contact.',
            [
              {
                text: 'Allow Access',
                onPress: () => { Linking.openURL('app-settings:') },
              },
              {
                text: 'Dont Allow',
              }
            ]
          );
        }
      }
    })();
  }
  const addToContacts = () => {
    let contactId = null;
    (async () => {
      // setLoading(true); //set to false when alerted after add/update
      const { data } = await Contacts.getContactsAsync();
      if (data.length > 0) {
        for (let i = 0; i < data.length; i++) {
          let contact = data[i];
          if (isContactAMatch(contact, customer)) {
            console.log('isMatch', contact);
            contactId = contact.id;
            break;
          } else {
            console.log('isNotMatch', contact);
          }
        }
        if (contactId) {
          updateContact(contactId);
        } else {
          addNewContact();
        }
        // data.forEach((contact) => {
        //   console.log(contact);
        // })
      }else{
        addNewContact();
      }
    })();

  }
  const isContactAMatch = (contact, user) => {
    if (
      contact.contactType === 'person'
      && contact.firstName === user.first_name
      && contact.lastName === user.last_name
      && contact.emails.includes(user.email_address)
    ) { return true; }
    return false;
  }
  const addNewContact = () => {
    (async () => {
      const contact = contactFromUser();
      const contactId = await Contacts.addContactAsync(contact);
      if (contactId) {
        await Contacts.presentFormAsync(contactId, contact, { cancelButtonTitle: 'Save' });
      }
      // setLoading(false);
      // alertContactEdit('add');
      console.log('added new contact', contact, contactId);
    })();
  }
  const updateContact = (contactId) => {
    (async () => {
      const contact = contactFromUser(contactId);
      await Contacts.updateContactAsync(contact);
      if (contactId) {
        await Contacts.presentFormAsync(contactId, contact, { cancelButtonTitle: 'Save' });
      }
      // alertContactEdit('update');
      // setLoading(false);
      console.log('updated existing contact', contact, contactId);
    })();
  }
  const contactFromUser = (contactId) => {
    let contact = {};
    contact[Contacts.Fields.ContactType] = Contacts.ContactTypes.Person;
    contact[Contacts.Fields.FirstName] = customer.first_name;
    contact[Contacts.Fields.LastName] = customer.last_name;
    contact[Contacts.Fields.Emails] = [
      {
        email: customer.email_address,
        isPrimary: false,
        label: 'Email Address'
      },
    ];
    contact[Contacts.Fields.PhoneNumbers] = [];
    if (customer.mobile){
      contact[Contacts.Fields.PhoneNumbers].push({
        number: customer.mobile,
        isPrimary: false,
        digits: stripPhoneNumber(customer.mobile),
        label: 'Mobile Phone Number'
      });
    }
    if (customer.home) {
      contact[Contacts.Fields.PhoneNumbers].push({
        number: customer.home,
        isPrimary: false,
        digits: stripPhoneNumber(customer.home),
        label: 'Home Phone Number'
      });
    }
    contact[Contacts.Fields.Addresses] = [{
      street: customer.street,
      city: customer.city,
      country: customer.country,
      region: customer.state,
      postalCode: customer.zip_code,
      label: 'Customer Address',
    }];
    if (contactId) {
      contact.id = contactId;
    }
    return contact;
  }

  // call
  const phoneCall = (phoneNumber) => {
    Linking.openURL('tel:' + phoneNumber);
  }
  // email
  const emailCompose = async (emailAddress) => {
    MailComposer.composeAsync({
      recipients: [emailAddress],
    });
  }
  // address (directions)
  const openAddress = () => {
    console.log('openAddress()', customer.full_address);
    const address = encodeURIComponent(customer.full_address);
    if(Platform.OS === 'web'){
      WebBrowser.openBrowserAsync(`https://maps.google.com/maps?daddr=${address}`);
    }else{
      const company = Platform.OS === "ios" ? "apple" : "google";
      Linking.openURL(`http://maps.${company}.com/maps?daddr=${address}`);
    }
  }

  const goBack = () => {
    if (navigation.canGoBack()) {
      navigation.goBack();
    } else {
      linkTo('/customers');
    }
  }

  return (
    <SafeAreaView style={CS.safe}>
      <BackgroundGradient />
      <Loader animating={loading} />
      {!loading &&
      <ScrollView keyboardShouldPersistTaps='handled' ref={scrollRef} style={[CS.scrollViewStyle, { marginTop: 10 }]} contentContainerStyle={[CS.scrollViewContentContainerStyle, { paddingHorizontal: 10 }]}>
        <TouchableOpacity onPress={goBack}>
          <FontAwesome5 name="arrow-left" size={24} color="white" />
        </TouchableOpacity>
        <View style={styles.avatarContainer}>
          <UserAvatar size='xlarge' userId={customer.id} avatar={customer.avatar} verified={customer.verified} />
          {/* <UserAvatar size='xlarge' userId={customer.id} avatar={customer.avatar} verified={"Verified"} /> */}
        </View>
        <Text style={[CS.largeText, CS.boldText, CS.yellowText, CS.centerText, { marginVertical: 20 }]}>{customer.first_name + ' ' + customer.last_name}</Text>
        <View style={{ marginBottom: 20 }}>
          <Button text='Invite to My Project' onPress={() => invite} />
        </View>
        {Platform.OS !== 'web'
          ?
          <View style={{ marginBottom: 20 }}>
            <Button text='Add to Contacts' onPress={() => checkAddToContacts} color='blue' icon={addContactIcon} />
          </View>
        : null
        }

        <View style={[CS.rowContainer, styles.contactRow]}>
          <View style={styles.contactIcon}>
            <FontAwesome name="phone" size={24} color={Colors.lightBlue2} />
          </View>
          <TouchableOpacity onPress={() => phoneCall(customer.mobile || customer.home)}>
            <Text style={styles.contactText}>{customer.mobile || customer.home}</Text>
          </TouchableOpacity>
        </View>
        <View style={[CS.rowContainer, styles.contactRow]}>
          <View style={styles.contactIcon}>
            <FontAwesome name="envelope" size={24} color={Colors.lightBlue2} />
          </View>
          <TouchableOpacity onPress={() => emailCompose(customer.email_address)}>
            <Text style={styles.contactText}>{customer.email_address}</Text>
          </TouchableOpacity>
        </View>
        <TouchableOpacity activeOpacity={0.6} onPress={openAddress} style={[CS.rowContainer, styles.contactRow]}>
          <View style={styles.contactIcon}>
            <MaterialIcons name="location-on" size={24} color={Colors.lightBlue2} />
          </View>
          <Text style={styles.contactText}>{customer.full_address}</Text>
        </TouchableOpacity>
        {/* 43.679853, -79.669913 */}
        {(customer.latitude && customer.longitude) &&
          (Platform.OS !== 'web' ? 
          <MapView onPress={openAddress} style={styles.map} region={{ latitude: customer.latitude, longitude: customer.longitude, latitudeDelta: 0.02, longitudeDelta: 0.02 }} zoomEnabled={false} scrollEnabled={false}>
            <Marker coordinate={{ latitude: customer.latitude, longitude: customer.longitude }} title={customer.name} description={customer.full_address} />
          </MapView>
          : null)
        }

        {/* <Text style={[CS.smallTitle, CS.lightText]}>Projects</Text> */}
        {/* {projects.map(p => {
          return (
            <View style={{ marginBottom: 10 }} key={p.id}>
              <ProjectPreview project={p} showCompleted={true} />
            </View>
          )
        })} */}
        {isReady && projects.length >= 1 &&
          <View style={{ marginBottom: 10 }}>
            <FlashList
              data={projects}
              renderItem={({ item }) => <ProjectPreview project={item} showCompleted={true} />}
              ItemSeparatorComponent={() => (<View style={{ height: 10 }} />)}
              keyExtractor={item => item.id.toString()}
              ListHeaderComponent={() => (<Text style={[CS.smallTitle, CS.lightText]}>Projects</Text>)}
              // refreshControl={<RefreshControl refreshing={loading} onRefresh={() => getProjects(selectedAddress)} colors={[Colors.yellow]} tintColor={Colors.yellow} />}
              // ListEmptyComponent={() => <Text style={[CS.smallText, CS.lightBlueText, CS.centerText]}>You have no projects in progress at the moment. Click the <Ionicons name="ios-add-circle" size={18} color={Colors.yellow} /> icon to start one.</Text>}
              numColumns={(isTablet || isWeb) ? 2 : 1}
              // numColumns={2}
              horizontal={false}
              columnWrapperStyle={(isTablet || isWeb) && { flex: 1, justifyContent: 'flex-start' }}
              estimatedItemSize={183}
            />
          </View>
        }
      </ScrollView>
      }
    </SafeAreaView>
  );

}

const styles = StyleSheet.create({
  avatarContainer: {
    alignItems: 'center',
  },
  contactRow: {
    marginTop: 10,
  },
  contactIcon: {
    alignItems: 'center',
    justifyContent: 'center',
    width: 24,
  },
  contactText: {
    fontSize: 20,
    fontWeight: 'bold',
    color: Colors.lightBlue2,
    marginLeft: 10,
    flex: 1,
  },
  map: {
    width: '100%',
    height: 200,
    marginTop: 10,
    borderRadius: 15
  },
});

export default CustomerScreen;